
import InitRequestPayload from "slotworks/model/gameplay/requests/init-request-payload";
import CommsManager from "slotworks/server/comms-manager";

export function InitCommand() {
    return CommsManager.request(new InitRequestPayload());
}
